import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { CountryModel } from '@app/common/models/country.model';


@Pipe({ name: 'countryName' })
@Injectable({
  providedIn: 'root'
})
export class CountryNamePipe implements PipeTransform {
  transform(country: CountryModel) {
    if (!country) {
      return '';
    }
    return country.nazev;
  }
}
